import { atom } from 'jotai';

import { ToastProps } from '@/components/basics/Toast';

const toastAtom = atom<ToastProps>({
  text: '',
  isOpen: false,
  type: 'success',
});

export default toastAtom;
